import { GridSortModel } from "@mui/x-data-grid";
import { TeamContactsSortOption } from "../queries/useContactsTable";

const sortMap: {
  [key: string]: {
    [key in "asc" | "desc"]: TeamContactsSortOption;
  };
} = {
  created: {
    asc: TeamContactsSortOption.CREATED_ASCENDING,
    desc: TeamContactsSortOption.CREATED_DESCENDING,
  },
  info: {
    asc: TeamContactsSortOption.FULL_NAME_ASCENDING,
    desc: TeamContactsSortOption.FULL_NAME_DESCENDING,
  },
  user: {
    asc: TeamContactsSortOption.USER_NAME_ASCENDING,
    desc: TeamContactsSortOption.USER_NAME_DESCENDING,
  },
  tags: {
    asc: TeamContactsSortOption.TAGS_ASCENDING,
    desc: TeamContactsSortOption.TAGS_DESCENDING,
  },
};

export const getSortOptionFromModel = (
  sortModel: GridSortModel,
): TeamContactsSortOption => {
  if (sortModel.length === 0) {
    return TeamContactsSortOption.CREATED_DESCENDING;
  }

  const { field, sort } = sortModel[0];
  if (!field || !sort) return TeamContactsSortOption.CREATED_DESCENDING;
  return sortMap[field][sort] || TeamContactsSortOption.CREATED_DESCENDING;
};
